function Header() {
    return (
        <div>
            <h2 style={{ fontWeight: "bold", margin: "0% 40%" }}>Our Reviews</h2>
            <hr style={{ width: "5%", height: "5px", backgroundColor: "deepskyblue", border: "none" }} />
        </div>
    );
}

export default Header;